export default "__VITE_ASSET__BldriQ8u__$_?url__"